import { Alert as MantineAlert, AlertProps as MantineAlertProps } from "@mantine/core";
import styles from "./styles.module.css";
import SVGAsset from "@/components/atoms/SVGAsset/SVGAsset";
import { ReactNode } from "react";

export const badgeColor = {
  primary: "primary",
  completed: "completed",
  warning: "warning",
  error: "error",
  success: "success",
  gray: "gray",
};

export interface AlertProps extends MantineAlertProps {
  children?: ReactNode;
  color?: string;
}

const Alert = ({ children, color, ...props }: AlertProps) => {
  const Icon = <SVGAsset name="warning-triangle" width="18" height="18" />;
  let bgColor: string,
    titleColor: string = "";
  switch (color) {
    case "warning":
      titleColor = "var(--color-warning-primary)";
      bgColor = "var(--color-warning-secondary)";
      break;
    case "error":
      titleColor = "var(--color-negate-primary)";
      bgColor = "var(--color-negate-secondary)";
      break;
    case "success":
      titleColor = "var(--color-success-primary)";
      bgColor = "var(--color-success-secondary)";
      break;
    default:
      bgColor = "var(--color-background-secondary)";
      titleColor = "var(--color-text-tertiary)";
  }

  return (
    <MantineAlert
      {...props}
      icon={Icon}
      classNames={{
        root: styles.alertRoot,
        body: styles.alertBody,
        icon: styles.alertIcon,
        message: styles.alertMessage,
      }}
      vars={() => ({
        root: {
          "--alert-bg": bgColor,
          "--alert-color": titleColor,
        },
      })}
      radius="xs"
    >
      {children}
    </MantineAlert>
  );
};

export default Alert;
